export default __webpack_public_path__ + "static/media/virtual-bg25.859af9fc.png";